module.exports = __webpack_public_path__ + "img/webtoon_title_img.9f65013.png";